import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { resetSelectedApplicant } from '../_redux/SelectedApplicantSlice';
import { resetHighlightFilter } from '../_redux/HighlightSlice';

const moduleViewUrls = {
  applicant: {
    card: '/ats/layout/applicants/list/landing',
    table: '/ats/layout/applicants/landing',
  },
  jobposting: {
    card: '/ats/layout/jobpostings/list/landing',
    table: '/ats/layout/jobpostings/landing',
  },
};

const ViewToggle = ({ view, type, onChange }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (event, newView) => {
    if (!newView || !moduleViewUrls[type]?.[newView]) return;
    dispatch(resetSelectedApplicant());
    dispatch(resetHighlightFilter([]));
    if (type === 'applicant') {
      Cookies.set('applicantViewPreference', moduleViewUrls[type][newView], { expires: 365 });
    } else if (type === 'jobposting') {
      Cookies.set('jobPostingViewPreference', moduleViewUrls[type][newView], { expires: 365 });
    }
    if (onChange) {
      onChange(newView);
      return;
    }
    navigate(moduleViewUrls[type][newView]);
  };

  return (
    <Box
      sx={{
        border: '1px solid #868788',
        borderRadius: '10px',
        padding: '4px',
        display: 'inline-flex',
        backgroundColor: '#ffffff',
      }}
    >
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleChange}
        sx={{
          '& .MuiToggleButton-root': {
            border: 'none',
            borderRadius: '8px !important',
            padding: '6px 14px',
            textTransform: 'none',
            color: '#6B7280',
          },
          '& .Mui-selected': {
            backgroundColor: '#3b4046 !important',
            color: '#FFFFFF !important',
          },
          '& .Mui-selected img': {
            filter: 'brightness(0) invert(1)',
          },
        }}
      >
        <ToggleButton value="card">
          <img
            src={process.env.PUBLIC_URL + '/assests/img/cardsIcon.svg'}
            alt=""
            style={{ marginRight: '8px' }}
          />
          Card View
        </ToggleButton>

        <ToggleButton value="table">
          <img
            src={process.env.PUBLIC_URL + '/assests/img/tableIcon.svg'}
            alt=""
            style={{ marginRight: '8px' }}
          />
          Table View
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ViewToggle;
